export enum TagType {
  Assessment = 1,
  Department = 2,
  Team = 3,
  User = 4,
  Lesson = 5,
}
